import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { SolicitudExService } from '../../datosbasicos/datosbasicosEx.service';
import { NumeroSeguridadViewModel } from './numerosseguridad.types';
import { NumerosSeguridadExService } from './numerosseguridad.service';
import { CopiaCFExService } from '../copiaCF/copiaCFEx.service';
import { CopiaCertificadoItemResultsViewModel } from '../copiaCF/copiaCFEx.types';

@Component({
    selector: 'app-numerosseguridad-edit',
    templateUrl: './numerosseguridad-edit.component.html',
})
export class NumeroSeguridadEditComponent extends ComponentBase implements OnInit {
    editMode = false;
    editTitle = 'Nuevo';

    cols: any[];
    public isCollapsed = false;
    visibilitySpinner = false;
    listPaginas: Tc[] = [
        { Id: 1, Descripcion: '1' },
        { Id: 3, Descripcion: '3' },
        { Id: 5, Descripcion: '5' },
    ];
    listPuntosInspeccion: Tc[];
    listZona: Tc[];
    resultCopiasCertificadoEx: CopiaCertificadoItemResultsViewModel;
    listCopiasCertificadoEx: Tc[];
    numeroSeguridad: NumeroSeguridadViewModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected globalService: GlobalService,
        protected exceptionHandler: ExceptionManager,
        private solicitudExService: SolicitudExService,
        private copiaCFExService: CopiaCFExService,
        private numerosSeguridadExService: NumerosSeguridadExService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.numeroSeguridad = new NumeroSeguridadViewModel();
        this.resultCopiasCertificadoEx = new CopiaCertificadoItemResultsViewModel();
    }

    ngOnInit() {
        this.globalService.getZonas().subscribe(res => {
            this.listZona = res;
        });

        let idNumeroSeguridad = +this.activatedRoute.snapshot.params['numeroSeguridad'];
        let idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        this.form = this.fb.group({
            IdSolicitud: idNumeroSeguridad,
            NumSeguridad: ['', Validators.required],
            IdPagina: [null, Validators.required],
            IdZona: null,
            IdPuntoInspeccion: null,
            IdCopiaEx: null,
        });

        this.form.controls['IdPuntoInspeccion'].disable();

        this.guardRefreshPage(idSolicitudEx);

        this.copiaCFExService.getCopiasCertificadoEx(idSolicitudEx).subscribe(res => {
            this.listCopiasCertificadoEx = res;
        });

        ////Comobo de Copias de Certificado
        ////hacemos el subscribe manual y no lo delegamos al async del HTML
        //this.copiaCFExService.getCopiasCertificadoEx(idSolicitudEx).subscribe(result => {

        //    this.resultCopiasCertificadoEx = result;

        //    if (this.resultCopiasCertificadoEx != null) {
        //        this.resultCopiasCertificadoEx.ResultList.forEach(x =>
        //            this.listCopiasCertificadoEx.push({
        //                Id: x.Id, Descripcion: x.Codigo
        //            }));
        //    }
        //    else {
        //        this.listCopiasCertificadoEx = [];
        //    }
        //}
        //);

        if (idNumeroSeguridad) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.numerosSeguridadExService.getNumeroSeguridad(idNumeroSeguridad).subscribe(result => {
                this.numeroSeguridad = result;
                this.updateForm();
            });
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    updateForm() {
        this.form.setValue({
            IdSolicitud: this.numeroSeguridad.IdSolicitudEx,
            NumSeguridad: this.numeroSeguridad.NumSeguridad,
            IdPagina: this.numeroSeguridad.IdPagina,
            IdZona: this.numeroSeguridad.IdZona,
            IdPuntoInspeccion: this.numeroSeguridad.IdPif,
            IdCopiaEx: this.numeroSeguridad.IdCopiaEx,
        });

        let _idZona: number = this.numeroSeguridad.IdZona != null ? this.numeroSeguridad.IdZona : 0;
        this.form.controls['IdPuntoInspeccion'].enable();
        this.globalService.getPuntosInspeccionByZona(_idZona).subscribe(res => {
            this.listPuntosInspeccion = res;
        });
    }

    onSelectZona(event: Tc) {
        //resetear combos dependientes de éste
        this.form.patchValue({
            IdPuntoInspeccion: null,
        });

        //detectar si ha pulsado el botón de eliminar selección del combo
        if (event != undefined) {
            const _idZona = this.form.controls['IdZona'].value;
            this.form.controls['IdPuntoInspeccion'].enable();

            //cargar combos dependientes
            this.globalService.getPuntosInspeccionByZona(_idZona).subscribe(res => {
                this.listPuntosInspeccion = res;
            });
        } else {
            //limpiar listas que alimentan los combos dependientes
            this.listPuntosInspeccion = [];
        }
    }

    onCleanButton() {
        this.form.setValue({
            NumSeguridad: '',
            IdPagina: null,
            IdZona: null,
            IdPuntoInspeccion: null,
            IdCopiaEx: null,
        });
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/envioEx', this.navMenuService.currentSolicitudExportacion.Id]);
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        let numeroSeguridad = new NumeroSeguridadViewModel();

        numeroSeguridad.IdSolicitudEx = this.navMenuService.currentSolicitudExportacion.Id;
        numeroSeguridad.IdPagina = this.form.value.IdPagina;
        numeroSeguridad.IdZona = this.form.value.IdZona;
        numeroSeguridad.IdPif = this.form.value.IdPuntoInspeccion;
        numeroSeguridad.NumSeguridad = this.form.value.NumSeguridad;
        numeroSeguridad.IdCopiaEx = this.form.value.IdCopiaEx;

        numeroSeguridad.Id = this.numeroSeguridad.Id;

        if (this.editMode) {
            this.numerosSeguridadExService.editNumeroSeguridad(numeroSeguridad).subscribe({
                next: () => {
                    this.addSuccessMessage('Nº Seguridad modificado correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        } else {
            this.numerosSeguridadExService.createNumeroSeguridad(numeroSeguridad).subscribe({
                next: () => {
                    this.addSuccessMessage('Nº Seguridad añadido correctamente');
                    this.onBack();
                },
                error: error => this.catchServerError(error),
            });
        }
    }
}
